import { historySentence } from '../../lib/portalAssets/history';
import type { PortalAssetHistoryEntry } from '../../types/portalAsset';

// THE ASSET'S DECISION HISTORY (2026-10-08) — shared by the client page and the
// staff dialog. Presentational: the host fetches. Every sentence comes from the
// pure historySentence.
//
// ⚠️ It exists because a club and Kyck are equal reviewers: without it, two
// authorities flipping one status is a silent tug-of-war.

export function AssetHistoryList({
  entries,
  loading,
  failed,
}: {
  entries: PortalAssetHistoryEntry[] | undefined;
  loading: boolean;
  failed: boolean;
}) {
  return (
    <section className="space-y-2 text-sm" aria-label="History">
      <h2 className="font-medium text-foreground">History</h2>
      {loading ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : failed ? (
        <p className="text-muted-foreground">We couldn't load the history of this asset.</p>
      ) : !entries || entries.length === 0 ? (
        <p className="text-muted-foreground">Nothing recorded yet.</p>
      ) : (
        <ol className="space-y-1" data-testid="asset-history">
          {entries.map((e) => (
            <li key={e.id} className="text-foreground">
              {historySentence(e)}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
